<template>
  <div class="setting-addel mr-l8">
    <!--button.scss-->
    <el-button v-if="status === 'PAUSE'" size="mini" @click="status = 'PLAY'"><img src="@/assets/img/icons/play.png"></el-button>
    <el-button v-else-if="status === 'PLAY'" size="mini" @click="status = 'PAUSE'"><img src="@/assets/img/icons/pause.png"></el-button>
    <el-button size="mini" @click="loadData"><img src="@/assets/img/icons/sync.png"></el-button>
  </div>
</template>

<script>
import { isNil } from 'lodash';

export default {
  name: 'WAutoReloadButton',
  props: {
    // 중복되는 taskName이 없어야된다. 등록전 확인 필요
    taskName: {
      type: String,
      default: null,
    },
    period: {
      type: Number,
      default: 30,
    },
    // 상위 컴포넌트에서 active 변수를 사용하지 않을시에는 true로 고정값을 넣는다
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      status: 'PAUSE',
    };
  },
  watch: {
    status: {
      handler(value) {
        if (!isNil(this.taskName) && this.active) {
          if (value === 'PLAY') {
            if (!this.$taskManager.existTask(this.taskName)) {
              this.createTaskManager();
            }
            this.$taskManager.startTask(this.taskName);
          } else {
            this.$taskManager.stopTask(this.taskName);
          }
        }
      },
    },
    active: {
      handler(value) {
        if (!value) {
          this.status = 'PAUSE';
          this.$taskManager.stopTask(this.taskName);
        }
      },
    },
  },
  mounted() {
    this.createTaskManager();
  },
  beforeDestroy() {
    this.$taskManager.removeTask(this.taskName);
  },
  methods: {
    loadData() {
      this.$emit('load-data');
    },
    createTaskManager() {
      this.$taskManager.createTask(this.taskName, this.period, () => {
        this.loadData();
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/button/AutoReloadButton.vue